<template>
  <PmNotificationLeaveRequestCancelRequestedPure
    v-bind="{ ...$attrs, ...props }"
    :is-jump-visible="can('approve', 'requests')"
    @open-details="isDetailsVisible = true"
  />

  <portal to="modal">
    <PmModalPure
      v-if="isDetailsVisible"
      title="Urlaubsantrag"
      @close="isDetailsVisible = false"
    >
      <PmRequestDetail
        v-if="isDetailsVisible"
        :id="props.leaveRequestId"
        type="leaveRequest"
      />
    </PmModalPure>
  </portal>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import PmNotificationLeaveRequestCancelRequestedPure, {
  type Props as PropsNotificationLeaveRequestCancelRequestedPure,
} from '@/components/PmNotification/PmNotificationLeaveRequestCancelRequested/PmNotificationLeaveRequestCancelRequestedPure.vue'
import PmRequestDetail from '@/components/PmRequestDetail/PmRequestDetail.vue'
import PmModalPure from '@/components/basics/PmModalPure.vue'
import { useAppAbility } from '@/composition/useAppAbility'

export type Props = PropsNotificationLeaveRequestCancelRequestedPure

const props = withDefaults(defineProps<Props>(), {})
const isDetailsVisible = ref(false)
const { can } = useAppAbility()
</script>
